<span class="no-expenses">
  <fa-icon [icon]="icon"></fa-icon>
</span>
<h3 class="text">{{ text }}</h3>
